import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { Router } from 'react-router';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';

import { setLanguage } from '@eventbrite/i18n';
import { REQUEST_SHAPE_PROP_TYPE } from '@eventbrite/site-structure';
import { getHistory, updateHistory } from '@eventbrite/react-router-history';
import { configureStore } from '@eventbrite/redux-configure-store';

import { initalizeApp } from './actions';
import reducer from './reducers';
import getRoutes from './routes';

export default class AttendeeRefundRequestApp extends PureComponent {
    static propTypes = {
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        helpLinks: PropTypes.shape({
            canIGetARefund: PropTypes.string,
            howToContactTheEventOrganizer: PropTypes.string,
            whereAreMyTickets: PropTypes.string,
            whereIsMyRefund: PropTypes.string,
        }),
        featureFlags: PropTypes.shape({
            newPostponedEventPolicy: PropTypes.bool,
        }),
        recaptcha2PublicKey: PropTypes.string,
    };

    constructor(props) {
        super(props);

        setLanguage(props.env.localeInfo.locale);

        const initialData = this._getInitialData();

        this._history = getHistory();

        this._store = configureStore({
            reducer,
            middleware: [thunk, routerMiddleware(this._history)],
        });

        this._history = syncHistoryWithStore(this._history, this._store);

        updateHistory(this._history, props.request);

        this._store.dispatch(initalizeApp(initialData));
    }

    componentDidUpdate() {
        // make sure we also update the history with any changes in the request
        updateHistory(this._history, this.props.request);
    }

    _getInitialData() {
        const { env, featureFlags, helpLinks, recaptcha2PublicKey, user } =
            this.props;

        return {
            env,
            featureFlags,
            helpLinks,
            recaptcha2PublicKey,
            user,
        };
    }

    render() {
        const routes = getRoutes(this.props);

        return (
            <Provider store={this._store}>
                <Router history={this._history} routes={routes} />
            </Provider>
        );
    }
}
